export * from './general/consts'
export * from './audio/consts'

export const GENERAL_REDUCER = 'general'
export const AUDIO_REDUCER = 'audio'
export const VIDEO_REDUCER = 'video'
